/**
 * Created by Jason on 2017-3-7.
 */

import '../lib/pnotify/css/pnotify.css';
import PNotify from '../lib/pnotify/js/pnotify';
//弹窗
import bootbox from '../../assets/lib/bootbox/bootbox';

let week = ['日', '一', '二', '三', '四', '五', '六']
function zero(num) {
    return num > 9 ? num : '0' + num;
}
let fileProp = {
    'pdf': {
        'icon': 'file-pdf-o',
        'color': '#d9534f'
    },
    'compress': {
        'icon': 'file-zip-o',
        'color': '#5bc0de'
    },

    //EXCEL
    'excel': {
        'icon': 'file-excel-o',
        'color': '#5cb85c'
    },

    //word
    'word': {
        'icon': 'file-word-o',
        'color': '#337ab7'
    },

    //ppt
    'powerPoint': {
        'icon': 'file-powerpoint-o',
        'color': '#f0ad4e'
    },
    'img': {
        'icon': 'file-image-o',
        'color': '#f0ad4e'
    },

    'txt': {
        'icon': 'file-text-o',
        'color': '#9b41e1'
    },
    'silk': {
        'icon': 'headphones',
        'color': '#9b41e1'
    },
    'mp3': {
        'icon': 'volume-up',
        'color': '#adc100'
    },
    '': {
        'icon': 'file-o',
        'color': '#666'
    }
};

let identityName = {
    'SERVICE_STAFF': '服务人员',
    'REVIEW_STAFF': '复核人员',
    'FINANCE_STAFF': '财务人员'
}

module.exports = {
    /**
     * 设置sessionId，登录完毕设置
     * @param token
     */
    saveToken (token) {
        localStorage.setItem('account.token', token);
    },
    getToken () {
        let token = localStorage.getItem('account.token');
        if (!token) {
            if (!/\/login\.html/.test(location.pathname)) {
                location = '/login.html';
            }
            return null;
        }
        return token;
    },
    /**
     * 删除token
     */
    removeToken: function () {
        localStorage.removeItem('account.token');
    },

    /***
     * 登出
     */
    logout() {
        this.removeToken();
        location = '/login.html';
    },
    saveCompanyId(id) {
        localStorage.setItem('account.companyId', id);
    },
    getCompanyId() {
        return localStorage.getItem('account.companyId');
    },
    getTimeStr(time) {
        let now = Date.now();
        let dirTime = now - time;
        if(dirTime < 60000) {
            return '刚刚';
        }
        if (dirTime < 3600000) {
            return Math.floor(dirTime / 60000) + '分钟前';
        }
        if (dirTime < 24 * 3600000) {
            return Math.floor(dirTime / 3600000) + '小时前';
        }
        let date = new Date();
        date.setTime(time);
        return zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日 周' + week[date.getDay()]
    },
    formatDate(timestamp){
        //日期时间补0
        function formatZero(num) {
            if (num < 10) {
                return '0' + num;
            } else {
                return num;
            }
        }
        let date = new Date(timestamp);
        let timeString = '';
        timeString += date.getFullYear() + '-';
        timeString += formatZero(+date.getMonth() + 1) + '-';
        timeString += formatZero(date.getDate()) + ' ';
        timeString += formatZero(date.getHours()) + ':';
        timeString += formatZero(date.getMinutes()) + '';
        return timeString;
    },
    getYearMonth(time) {
        let date = new Date();
        if (time) {
            date.setTime(time);
        }
        return date.getFullYear() + '年' + zero(date.getMonth() + 1)+'月';
    },
    getYearMonthDaySimple(time) {
        let date = new Date();
        if (time) {
            date.setTime(time);
        }
        return date.getFullYear() + '-' + zero(date.getMonth() + 1) + '-'+zero(date.getDate());
    },
    /**
     * 判断是否输入尖括号
     * @param str
     */
    hasHtmlTag(str) {
        return /<|>/.test(str);
    },
    /**
     * 判断姓名
     * @param str
     */
    isName(str) {
        return /^[\u4e00-\u9fa5]{2,6}$/.test(str.trim());
    },
    /**
     * 是否是手机
     * @param str
     */
    isPhone(str) {
        return /^1[3578]\d{9}$/.test(str.trim());
    },
    /**
     * 弹窗
     * @param title
     * @param content
     */
    /**
     * 判断html中文本长度
     * @param html
     */
    htmlLength(html) {
        return html.replace(/<.*?>/g, '').replace(/(\s|\t|\r|\n|&nbsp;)+/g, '').length;
    },
    error(title, content) {
        new PNotify({
            title: title,
            text: content || false,
            opacity: .8,
            type: 'error',
            buttons: {
                sticker: false
            }
        });
    },
    /**
     * 弹窗
     * @param title
     * @param content
     */
    info(title, content) {
        new PNotify({
            title: title,
            text: content || false,
            opacity: .8,
            type: 'info',
            buttons: {
                sticker: false
            }
        });
    },

    success(title, content) {
        new PNotify({
            title: title,
            text: content || false,
            opacity: .8,
            type: 'success',
            buttons: {
                sticker: false
            }
        });
    },
    /**
     * 自定义confirm
     * @param message
     * @param okCb
     */
    confirm(message, okCb, focusConfirm) {
        bootbox.confirm({
            message: message,
            size: "small",
            buttons: {
                confirm: {
                    label: '是',
                    className: 'btn-warning',
                    focus: focusConfirm
                },
                cancel: {
                    label: '否',
                    focus: !focusConfirm
                }
            },
            callback: function (result) {
                if (result) {
                    okCb();
                }
            }
        });
    },
    /**
     * 弹窗
     * @param title
     * @param message
     */
    alert(title, message, cb) {
        if (typeof message === 'function') {
            cb = message;
            message = title;
            title = undefined;
        }
        bootbox.alert({
            size: "small",
            title: title,
            message: message,
            callback: function () {
                cb && cb();
            }
        })
    },


    /**
     * 获取文件图标
     * @param fileType
     * @param fileName
     */
    getFileIcon(fileType, fileName) {
        fileType = fileType || "";
        if (!fileType && fileName) {
            fileType = fileName.match(/\.([^.]+)$/i);
            if (fileType) {
                fileType = fileType[1];
            }
        }

        fileType = fileType.toLowerCase();
        switch (fileType) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'bmp':
            case 'gif':
                fileType = 'img';
                //预览
                break;
            case 'doc':
            case 'docx':
            case 'docm':
            case 'dotm':
            case 'dotx':
                fileType = 'word';
                break;
            case 'xlsx':
            case 'xlsm':
            case 'xls':
            case 'xlsb':
                fileType = 'excel';
                break;
            case 'pptx':
            case 'ppsx':
            case 'ppt':
            case 'pps':
            case 'pptm':
            case 'potm':
            case 'ppam':
            case 'potx':
            case 'ppsm':
                fileType = 'powerPoint';
                break;
            case 'zip':
            case 'rar':
            case '7z':
            case 'iso':
                fileType = 'compress';
                break;
        }

        let type = fileProp[fileType] || fileProp[''];
        return `<i class="fa file-type fa-${type.icon}" style="background: ${type.color}"></i>`
    },

    /**
     * 是否是office文件
     */
    isOffice(type) {
        return ['doc','docx','docm','dotm','dotx','xlsx','xlsb','xls','xlsm','pptx','ppsx','ppt','pps','pptm','potm','ppam','potx','ppsm'].indexOf(type.toLowerCase()) !== -1
    },

    /**
     * 职务名称
     */
    getIdentityName(userData) {
        if (!userData.identityType) {
            return undefined;
        }
        return identityName[userData.identityType] || '工作人员'
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/util.js